import { handleActions } from 'redux-actions';
import {
  loadAllStates,
  paginateStates,
  filterStates,
  changeSortConfigState,
  loadAllStatesTranslate,
} from '../actions/stateActions';

const defaultState = {
  states: [],
  currentStates: [],
  statesTranslate: [],
  sortConfig: [],
};

export default handleActions(
  {
    [loadAllStates](state, action) {
      return { ...state, states: action.payload };
    },
    [loadAllStatesTranslate](state, action) {
      return { ...state, statesTranslate: action.payload };
    },
    [paginateStates](state, action) {
      const { page, pageSize } = action.payload;
      const start = (page - 1) * pageSize;
      const end = page * pageSize;
      const currentStates = [...state.states].slice(start, end);
      return { ...state, currentStates };
    },
    [filterStates](state, action) {
      const { value } = action.payload;
      const states = state.states.filter(
        (documentState) =>
          value === '' ||
          documentState.name.toLowerCase().includes(value) ||
          documentState.name.toUpperCase().includes(value)
      );
      return { ...state, states };
    },
    [changeSortConfigState](state, action) {
      const sortOption = state.sortConfig.find(
        (currentSortOption) => currentSortOption.field === action.payload
      );
      if (sortOption) {
        return sortOption.asc
          ? {
              ...state,
              sortConfig: state.sortConfig.map((currentSortOption) =>
                currentSortOption.field === sortOption.field
                  ? { ...currentSortOption, asc: false }
                  : currentSortOption
              ),
            }
          : {
              ...state,
              sortConfig: state.sortConfig.filter(
                (currentSortOption) => currentSortOption.field !== sortOption.field
              ),
            };
      }
      return {
        ...state,
        sortConfig: [...state.sortConfig, { model: 'State', field: action.payload, asc: true }],
      };
    },
  },
  defaultState
);
